import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT, FeedbackSubmitRequest, FeedbackSubmitResponse } from '@ld.consumer-portal/models';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FeedbackService {
  private readonly http = inject(HttpClient);
  private readonly env = inject(ENVIRONMENT);

  private get crmBaseUrl(): string {
    const fullUrl = this.env.appSettings.MelloServCRMUrl || '';

    if (this.isNativePlatform()) {
      return fullUrl;
    }

    if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
      try {
        const url = new URL(fullUrl);
        return url.pathname;
      } catch {
        return fullUrl;
      }
    }

    return fullUrl;
  }

  private isNativePlatform(): boolean {
    const capacitor = (window as unknown as { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor;
    return capacitor?.isNativePlatform?.() ?? false;
  }

  async submitFeedback(request: FeedbackSubmitRequest): Promise<FeedbackSubmitResponse> {
    const url = `${this.crmBaseUrl}/Feedback/Create`;

    const payload = {
      CustomerIdentifier: request.customerId || '',
      Subject: request.subject || '',
      Message: request.message || '',
      Rating: request.rating || 0,
      ConactCustomer: request.contactCustomer ?? false,
      ContactInformation: request.contactInformation || '',
      LoanNumber: request.loanNumber || '',
      ZipCode: request.zipCode || '',
    };

    const response = await firstValueFrom(this.http.post<FeedbackSubmitResponse>(url, payload));
    return response ?? { success: true };
  }

  private buildMessage(userMessage: string): string {
    return userMessage;
  }
}
